import { render, staticRenderFns } from "./ChangeStatusHistory.vue?vue&type=template&id=07b8e70c"
import script from "./ChangeStatusHistory.vue?vue&type=script&lang=js"
export * from "./ChangeStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports